"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownloadCSVButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPapaparse = require("react-papaparse");

var _reactRedux = require("react-redux");

var _findPersonasIndividual = require("../reducers/findPersonasIndividual");

var _groupedPersona = require("../reducers/groupedPersona");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DownloadCSVButton = function DownloadCSVButton(_ref) {
  var currentDataPage = _ref.currentDataPage;
  var data = (0, _reactRedux.useSelector)(currentDataPage === 'audience-profiling' ? _groupedPersona.groupedPersonasToCSV : _findPersonasIndividual.formattedIndividualPersonasToCSV);
  return /*#__PURE__*/_react["default"].createElement(_reactPapaparse.CSVDownloader, {
    type: "button",
    className: "csv-download__button " + (!data || !data.data || !data.data.length ? 'disabled' : ''),
    filename: (currentDataPage !== null && currentDataPage !== void 0 ? currentDataPage : 'data-page') + "-" + new Date().toISOString().split('T')[0],
    data: data
  }, "Download CSV");
};

exports.DownloadCSVButton = DownloadCSVButton;